import React from 'react'
import Modal, {ModalBody, ModalFooter, ModalHeader} from "../../../../components/bootstrap/Modal";
import Button from "../../../../components/bootstrap/Button";
import {useTranslation} from "react-i18next";
import secondary from "../../../../assets/img/secondary.svg";

const CancellRequestCompletedModal = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation()

  return (
    <Modal
      isCentered
      isStaticBackdrop
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      size={'sm'}
    >
      <div className='modal-wraped mx-3'>
        <ModalHeader />
        <ModalBody>
          <div className='text-center'>
            <img src={secondary} alt="리스트 아이콘" width={60} />
            <h5 className='fw-bold mt-4 lh-base'>취소 요청 <span className='text-secondary'>완료</span></h5>
            <p className='text-muted mb-0'>
            {t('successConfirmPopup.checkApplicationStatusOnEApproval1')}
              <br/>전자결재에서 확인해주세요.
            </p>
          </div>   
        </ModalBody>
        <ModalFooter className='justify-content-center'>
          <Button
            className='w-100'
            style={{
              borderRadius: 7,
            }} 
            color='secondary'
            onClick={() => setIsOpen(false)}
          >
            <span className='px-3'>{t('확인')}</span>
          </Button>
        </ModalFooter>
    </div>
    </Modal>
  )
}

export default React.memo(CancellRequestCompletedModal)